import { PrintProvider } from 'contexts/PrintContext';
import PrintLayout from 'layouts/PrintLayout';

interface PrintRouteProps {
  Component: React.ComponentType;
}

const PrintRoute: React.FC<PrintRouteProps> = ({ Component }) => {
  return (
    <PrintProvider>
      <PrintLayout>
        <Component />
      </PrintLayout>
    </PrintProvider>
  );
};

export default PrintRoute;